export interface RefreshState {
  expiresAt?: number; // milliseconds since the epoch
}

export interface AuthenticatedState {
  authenticated: true;
  entitlements: string[];
  expiresAt?: number; // milliseconds since the epoch
  refresh?: RefreshState;
  userId: string;
}

export interface UnauthenticatedState {
  authenticated: false;
  cause?: Error;
  unauthenticatedReason: string;
}

export type AuthState = AuthenticatedState | UnauthenticatedState;

export type AuthStateListener = (authState: AuthState) => void;

export type AuthStateListenerRemover = () => void;

export const NewAuthState = {
  Error: (cause: Error): AuthState => ({
    authenticated: false,
    cause,
    unauthenticatedReason: 'see cause',
  }),
  Reason: (reason: string): AuthState => ({
    authenticated: false,
    unauthenticatedReason: reason,
  }),
};
